<script>
export default {
  page: {
    title: 'About page...',
    meta: [{ name: 'description', content: 'About page...' }],
  },
}
</script>

<template>
  <div :class="$style.pageContainer">
    <v-img
      :src="require('@assets/images/healthbook_logo.svg')"
      :class="$style.logoImg"
    ></v-img>
    <div>
      <p :class="$style.titleText">Who we are</p>
      <p :class="['pb-7', $style.contentText]">
        At HealthBook+, we understand that you’re busy and don’t always have the
        time you’d like to take care of yourself. That’s why we believe that
        quality healthcare should be accessible to anyone, when and where they
        need it. HealthBook+ is an early identification and guided health
        platform for everyone, giving access to immediate support with
        personalized health solutions based on your individual needs.
      </p>
      <p :class="$style.contentText">
        HealthBook+ is a simple-to-use digital-first care platform that guides
        an individual’s next best health action using advanced AI while keeping
        their data private and secure. HealthBook+ identifies potential
        conditions early on and facilitates access to healthcare screening and
        services through secure chats, peer coaching, and education.
      </p>
    </div>
    <div>
      <p :class="$style.titleText">What we believe</p>
      <p :class="['pb-7', $style.contentText]">
        We believe that owning your personal health data is a fundamental human
        right. We believe that a person will make the best choices for their
        care if they’re given the right information to make an informed
        decision. That’s why we are committed to providing the tools and
        resources to decide your next best health action.
      </p>
      <ul :class="$style.contentText">
        <li
          ><span class="font-weight-bold">Open</span> - We are honest and
          transparent and act with integrity.</li
        >
        <li
          ><span class="font-weight-bold">World-class</span> - We aspire to be
          the best and deliver outstanding quality.</li
        >
        <li
          ><span class="font-weight-bold">Non-judgmental</span> - We treat
          everyone with respect and never assume.</li
        >
        <li
          ><span class="font-weight-bold">Empowering</span> - We enable others
          to be the best they can be.</li
        >
        <li
          ><span class="font-weight-bold">Resourceful</span> - We create
          innovative solutions to difficult problems.</li
        >
      </ul>
    </div>
    <div>
      <p :class="$style.titleText">Your privacy is our priority</p>
      <ul :class="$style.contentText">
        <li>Hosted on Amazon Web Service</li>
        <li>SOC II Type 1</li>
        <li>HIPAA compliant</li>
        <li>2FA authentication</li>
        <li>End-to-end data encryption</li>
        <li class="font-weight-bold"
          >Your health data will not be sold or used without your consent.
          Ever.</li
        >
      </ul>
    </div>
  </div>
</template>

<style lang="scss" module>
.pageContainer {
  max-width: 1200px;
  padding: 20px 10px 20px 120px !important;
  margin: 0 !important;
}

.logoImg {
  width: 356px;
  height: 72px;
  margin-bottom: 15px;
}

.titleText {
  padding: 14px 0;
  margin: 0 !important;
  font-size: 18px;
  font-weight: bold;
  line-height: 22px;
}
.contentText {
  margin: 0 !important;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
}
@media screen and (max-width: 1200px) {
  .pageContainer {
    padding-left: 28px !important;
  }
}

@media screen and (max-width: 450px) {
  .pageContainer {
    padding-left: 20px !important;
  }
}
</style>
